import PlaylistAddIcon from "@mui/icons-material/PlaylistAdd";
import CreationDialog from "../../../../components/dialogs/CreationDialog.js";

export default function CreateRunDialog({
  locales,
  onInput,
  onClose,
  onConfirm,
  name,
  show,
}) {
  return (
    <CreationDialog
      actionButtonText={locales["runs.create.button"]}
      bodyPrimary={locales["runs.create.body"]}
      icon={PlaylistAddIcon}
      inputId="create-run-name"
      inputLabel={locales["runs.create.label"]}
      inputValue={name}
      locales={locales}
      onActionClick={onConfirm}
      onInput={onInput}
      onClose={onClose}
      show={show}
    />
  );
}
